export const dashboardMenu = {
  dashboard: {
    id: "dashboard",
    text: "Dashboard",
    path: "/",
    iconName: "LayoutDashboard",
    subMenu: null,
  },
};
export const buildingMenu = {
  building: {
    id: "building",
    text: "My Buildings",
    path: "/building",
    iconName: "Building2",
    subMenu: null,
  },
  buildingDetails: {
    id: "buildingDetails",
    text: "Building Details",
    path: "building/details",
    hide: true,
  },
};

export const financialYearMenu = {
  financialYear: {
    id: "financialYear",
    text: "Financial Year End",
    path: "/financial-year",
    iconName: "CalendarDays",
    subMenu: null,
  },
  financialYearDetails: {
    id: "financialYearDetails",
    text: "Financial Year End Details",
    path: "financial-year/details",
    hide: true,
  },
};
export const termDepositMenu = {
  termDeposit: {
    id: "termDeposit",
    text: "Term Deposit",
    path: "/term-deposit",
    iconName: "Receipt",
    subMenu: null,
  },
  termDepositDetails: {
    id: "termDepositDetails",
    text: "Term Deposit Details",
    path: "term-deposit/details",
    hide: true,
  },
  termDepositSendReminder: {
    id: "termDepositSendReminder",
    text: "Term Deposit Send Reminder",
    path: "term-deposit/reminder",
    hide: true,
  },
  termDepositRollBack: {
    id: "termDepositRollBack",
    text: "",
    path: "term-deposit/rollback-instructions",
    hide: true,
  },
  termDepositSendReminderForms: {
    id: "termDepositSendReminderForms",
    text: "Term Deposit Send Reminder",
    path: "term-deposit/reminder/forms",
    hide: true,
  },
};
export const insuranceRenewalMenu = {
  insuranceRenewal: {
    id: "insuranceRenewal",
    text: "Insurance Renewal",
    path: "/insurance-renewal",
    iconName: "ShieldUser",
    subMenu: null,
  },
};

export const meetingRegisterMenu = {
  meetingRegister: {
    id: "meetingRegister",
    text: "Meeting Register",
    path: "/meeting-register",
    iconName: "Users",
    subMenu: null,
  },
};

export const profileMenu = {
  profile: {
    id: "profile",
    text: "Profile",
    path: "/profile",
    iconName: "SquareUser",
    subMenu: null,
    hide: true,
  },
};
export const configurationMenu = {
  configuration: {
    id: "configurations",
    text: "Configurations",
    path: "configurations",
    iconName: "Cog",
    subMenu: {
      // menuManager: {
      // 	id: 'menuManager',
      // 	text: 'Menu Manager',
      // 	path: 'web-menu',
      // 	iconName: 'Menu',
      // },
      menuManager: {
        id: 'menuManager',
        text: 'Menu Manager',
        path: 'web-menu',
        iconName: 'Menu',
      },
      viewWebMenu: {
        id: 'viewWebMenu',
        text: 'View Menu Details',
        path: 'web-menu/view',
        iconName: 'Eye',
        hide: true,
      },
      rolesManagement: {
        id: "rolesManagement",
        text: "Roles Management",
        path: "roles",
        iconName: "UserCheck",
      },
      userManagement: {
        id: "userManagement",
        text: "User Management",
        path: "users-management",
        iconName: "UserCog",
      },
      meetingRegisterSettings: {
        id: "meetingRegisterSettings",
        text: "Meeting Register",
        path: "meeting-register-settings",
        iconName: "Handshake",
      },
    },
  },
};

export const assistanceMenu = {
  assistance: {
    id: "assistance",
    text: "Arya AI",
    path: "assistance",
    iconName: "Bot",
    subMenu: null,
  },
};
